"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "sha2/5.0.2";
//# sourceMappingURL=_version.js.map